export default "__VITE_ASSET__DbisMEya__"